import React from 'react';
import { MapPin, Phone, Instagram, Sparkles } from 'lucide-react';

const MaintenancePage = ({ message }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 flex items-center justify-center px-6 py-12">
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/3 rounded-full blur-3xl"></div>
      </div>

      <div className="relative text-center max-w-xl">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src="/assets/logo.png" 
            alt="Estel Regals" 
            className="h-32 md:h-40 mx-auto drop-shadow-lg"
          />
        </div>

        {/* Sparkle decoration */}
        <div className="flex items-center justify-center gap-3 mb-6">
          <Sparkles className="h-5 w-5 text-primary/60" />
          <span className="text-sm tracking-widest uppercase text-muted-foreground">Pedralbes, Barcelona</span>
          <Sparkles className="h-5 w-5 text-primary/60" />
        </div>

        {/* Main title */}
        <h1 className="font-heading text-4xl md:text-6xl font-medium text-foreground mb-6">
          Tornem aviat
        </h1>

        {/* Message */}
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-slate-100 p-8 mb-8">
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            {message || "Estem fent millores a la botiga per oferir-te una millor experiència. Gràcies per la teva paciència!"}
          </p>
        </div>

        {/* Contact info card */}
        <div className="bg-primary text-primary-foreground rounded-2xl shadow-xl p-8">
          <h2 className="font-heading text-xl mb-6">Mentrestant, vine a veure'ns!</h2>
          
          <div className="space-y-4">
            <a 
              href="https://maps.app.goo.gl/ePhjMgw2xwxFtRRJ9" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 hover:opacity-80 transition-opacity"
            >
              <MapPin className="h-5 w-5 flex-shrink-0" />
              <span>Carrer Capità Arenas, 25, Baixos · 08034 Barcelona</span>
            </a>
            
            <a 
              href="tel:+34932040216" 
              className="flex items-center justify-center gap-3 hover:opacity-80 transition-opacity"
            >
              <Phone className="h-5 w-5 flex-shrink-0" />
              <span className="text-lg font-medium">932 040 216</span>
            </a>
            
            <a 
              href="https://www.instagram.com/terestel/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-3 hover:opacity-80 transition-opacity"
            >
              <Instagram className="h-5 w-5 flex-shrink-0" />
              <span>@terestel</span>
            </a>
          </div>
        </div>

        {/* Footer */}
        <p className="mt-8 text-sm text-muted-foreground">
          © {new Date().getFullYear()} Estel Regals · Gairebé 50 anys al teu costat
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
